"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabNav = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../colors");
exports.TabNav = styled_components_1.default.ul `
  margin: 0;
  padding: 0 15px;
  list-style-type: none;
  border-bottom: 2px solid ${colors_1.tabNavBorderColor};

  display: flex;
  flex-wrap: wrap;
`;
//# sourceMappingURL=tab-nav.js.map